export default {
  namespaced: true,
  hanwha_camera: {
    title: "hanwha Camera | hanwha Cameras",
    hanwha: 'hanwha',
    name: "name",
    channel: "channel",
    type: "type",
    ip: "IP",
    class: "class",
    encryption: "encryption",
    poe: "has POE?",
    poe_port: "POE port",
    http_port: "http port",
    https_port: "https port",
    port: "port",
    port_type: "port type",
    rtsp_port: "RTSP port",
    serial_number: "serial number",
    user: "user",
    dvr_validation: "you need to select an DVR",
    device_information: "Device Information",
    confirm_delete: "Are you sure to delete the camera '%camera%'?" ,
    state: 'State',
    fisheye: 'Fisheye',
    send_to_seproban: 'Send to SEPROBAN',
    group: 'Grupo',
    user_id: 'User Id',
    username: 'Username',
    user_level: 'User Level',
    password: 'Password',
    viewer_access: 'Viewer Access',
    password_confirm: 'Password Confirm for Save Changes',
    change_password: 'Change password',
    current_password: 'Current password',
    new_password: 'New password',
    confirm_new_password: 'New password confirm',
    protocol: 'Protocol',
    local_ip: 'Local IP',
    model: 'Model',
    group_id: 'Group Id'
  },
};
